<div>
  <ion-row>
    <ion-col size="10" [size]="attachmentUrl ? 10 : 12">
      <img style="border: 1px solid rgba(136, 51, 102, 0);" *ngIf="type=='IMAGE'" [class]="attachmentCssClass"
        [src]="attachmentUrl ? attachmentUrl.mainurl?attachmentUrl.mainurl : attachmentUrl : defaultAttachmentUrl"
        (click)="clickAttachment()" />

      <audio width="100%" height="auto" controls *ngIf="type=='AUDIO'" [class]="attachmentCssClass"
        (click)="clickAttachment()">
        <source src="{{attachmentUrl ? attachmentUrl : defaultAttachmentUrl}}" type="video/mp4">
        Your browser does not support the video tag.
      </audio>
      <video width="100%" height="auto" controls *ngIf="type=='VIDEO'" [class]="attachmentCssClass"
        (click)="clickAttachment()">
        <source src="{{attachmentUrl ? attachmentUrl : defaultAttachmentUrl}}" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      <div *ngIf="type=='OTHER'" [class]="attachmentCssClass">
        <div *ngIf="!attachmentUrl" (click)="clickAttachment()"
          style="border:1px dashed blue; padding: 36px; width: 115px; border-radius: 10px; margin: 20px;"
          class="textCenter">
          <ion-icon name="camera-outline" style="color: blue; font-size: 30px;"></ion-icon>
        </div>
        <ion-card *ngIf="attachmentUrl" class="padding2 cursorpoint">
          <span
            (click)="clickAttachment()">{{attachmentUrl.filename?attachmentUrl.filename:utilityService.getFileNameFromGCS(attachmentUrl)}}</span>
          <ion-icon class="floatRight font1_5" *ngIf="attachmentUrl && canEdit" name="close-circle" color="danger"
            (click)="deleteAttachment()"></ion-icon>
        </ion-card>
      </div>
      <input #myFile type="file" (change)="onFileChange($event)" style="display: none" />
    </ion-col>
    <ion-col size="2" *ngIf="attachmentUrl && canEdit">
      <ion-icon color="danger" name="close-circle" style="margin-left: -10px;" (click)="removeAttachment()"
        class="font1_6"></ion-icon>
    </ion-col>
  </ion-row>
</div>
<ion-modal [isOpen]="isCropperModalOpen" (didDismiss)="isCropperModalOpen = false">
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Crop Image</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="isCropperModalOpen = false">
            <ion-icon name="close-outline" style="color: red; font-size: 20px;"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="false" format="png"
        [aspectRatio]="1/1" [imageBase64]="imageChangedEvent" (imageCropped)="imageCropped($event)"
        (loadImageFailed)="loadImageFailed()" [imageQuality]="80" style="width: 100%; height: auto;">
      </image-cropper>
    </ion-content>
    <ion-footer>
      <ion-toolbar>
        <ion-button expand="full" color="secondary" (click)="saveCroppedImage(croppedImage)">Save Image</ion-button>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>